import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import DocType from "../pages/Admin/SystemConfig/DocType";
import Users from "../pages/Admin/Users";
import ServicesTypes from "../pages/Admin/SystemConfig/ServicesTypes";
import EmailTemplate from "../pages/Admin/SystemConfig/EmailTemplates";
import ResetPassword from "../pages/Admin/Users/ResetPassword";
import AuditLog from "../pages/Admin/SystemLogs/AuditLog";
import EmailLog from "../pages/Admin/SystemLogs/EmailLog";
import AdminSettings from "../pages/Admin/Settings/index";
import Notifications from "../pages/Admin/Notifications";
import Invoices from "../pages/Admin/Invoices";
import RiseInvoice from "../pages/Admin/Invoices/RiseInvoice";
// import Reports from "../pages/Admin/Reports";
import Notifaction from "../pages/Admin/Settings/Notification";
import Dashboard from "../pages/Admin/Dashboard";
import ProviderType from "../pages/Admin/SystemConfig/ProvideType/index";
import Reports from "../pages/Admin/Reports";
import ClientOverview from "../pages/Admin/Reports/ClientsOverview";
import OverallRevenue from "../pages/Admin/Reports/OverallRevenue";
import ProvidersOverview from "../pages/Admin/Reports/ProvidersOverview";
import WorkersOverview from "../pages/Admin/Reports/WorkersOverview";
function useLocalStoragePath() {
  const location = useLocation();
  useEffect(() => {
    localStorage.setItem("currentPath", location.pathname);
  }, [location.pathname]);
  return location.pathname;
}
export const AdminPortalAdminRoutes = () => {
  const currentPath = useLocalStoragePath();
  return (
    <React.Fragment>
      <Routes>
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="audit-log" element={<AuditLog />} />
        <Route path="email-log" element={<EmailLog />} />
        <Route path="users" element={<Users />} />
        <Route path="notifications" element={<Notifications />} />
        <Route path="doc-type" element={<DocType />} />
        {/* <Route path="reset-password" element={<ResetPassword />} /> */}
        <Route path="services-types" element={<ServicesTypes />} />
        <Route path="email-templates" element={<EmailTemplate />} />
        <Route path="provider-types" element={<ProviderType />} />
        <Route path="admin-setting" element={<AdminSettings />} />
        <Route path="invoices" element={<Invoices />} />
        <Route path="invoices/raise-invoice" element={<RiseInvoice />} />
        <Route path="reports" element={<Reports />} />
        
        <Route path="reports/clients-overview" element={<ClientOverview />} />
        <Route path="reports/providers-overview" element={<ProvidersOverview />} />
        <Route path="reports/workers-overview" element={<WorkersOverview />} />
        <Route path="reports/overall-revenue" element={<OverallRevenue />} />
      </Routes>
    </React.Fragment>
  );
};
